/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/shortcutFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoShortcutField implements angular.IDirective {
        private filter: angular.IFilterService;
        restrict = "E";
        scope = {
          currentValue: "=ngModel",
          contentKey: "@",
          disabled: "=ngDisabled",
          required: "=ngRequired",
          tabIndex: "=?"
        };

        template = "<div><div class=\"meevo_input_wrapper\"><label translate=\"{{::contentKey}}\"></label><div ng-class=\"{'ng-dirty required_red_bubble' : required && !currentValue}\"></div></div><input maxlength=\"10\" id=\"{{contentKey + $parent.$index }}\" ng-class=\"{' red_border_invalid' : (!currentValue && required)}\" type=\"text\" ng-model=\"maskedValue\" ng-disabled=\"disabled\" ng-required=\"required\" tabindex=\"{{tabIndex || 0}}\"/></div>";

        constructor($filter: angular.IFilterService) {
            this.filter = $filter;
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var filter = this.filter;

            scope.$watch('currentValue', currentVal => {
                var newMaskedVal = "";
                
                newMaskedVal = filter<any>('meevoShortcut')(currentVal);
                
                if (scope.maskedValue !== newMaskedVal) {
                    scope.maskedValue = newMaskedVal;
                }

            });

            scope.$watch('maskedValue', maskedVal => {

                var newUnmaskedVal = "";

                newUnmaskedVal = maskedVal; // doesn't need to be unmasked

                if (scope.currentValue !== newUnmaskedVal) {
                    scope.currentValue = newUnmaskedVal;
                }

            });

            element.on("click", (event: JQueryEventObject) => {
                if (!scope.isDisabled) {
                    let target: any = event.target || event.srcElement;
                    if (target.id === scope.id) {
                        target.select();
                    }
                    event.preventDefault();
                }
            });

            element.on("keydown", (event: JQueryEventObject) => {
                // If backspace, tab, delete, or arrow keys, allow key press
                if (event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40 || event.keyCode === 96) {
                    return true;
                }

                //if (scope.currentValue.length == 10) { // shortcuts can only be 10 characters long
                //    return false;
                //}

                var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
                var charStr = String.fromCharCode(charCode);
                if (!(/^([0-9a-zA-Z]+(\.)?([0-9a-zA-Z]+)?)$/.test(charStr)) 
                        && event.keyCode !== 190 // handles period key
                        ) { // allows only alpha/numeric characters and period, no spaces
                    event.preventDefault();
                    return false;
                }

                return true;
            });
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter) => {
                return new MeevoShortcutField($filter);
            };

            directive.$inject = ["$filter"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoShortcutField", MeevoShortcutField.factory());
}